var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21119 0.93399H4.10319V2.30299H8.21019L8.21119 0.93399ZM5.47319 9.83399H6.84219V5.72599H5.47319V9.83399ZM10.9732 5.30899L11.9452 4.33699C11.6533 3.9869 11.3303 3.66392 10.9802 3.37199L10.0082 4.34399C8.77812 3.36059 7.21817 2.88557 5.64877 3.0165C4.07938 3.14744 2.61971 3.87438 1.5696 5.04802C0.519494 6.22165 -0.0413156 7.75285 0.00237365 9.32709C0.046063 10.9013 0.690934 12.3991 1.80452 13.5127C2.9181 14.6262 4.41584 15.2711 5.99008 15.3148C7.56432 15.3585 9.09553 14.7977 10.2692 13.7476C11.4428 12.6975 12.1697 11.2378 12.3007 9.6684C12.4316 8.09901 11.9566 6.53906 10.9732 5.30899ZM6.16018 13.942C5.21242 13.942 4.28593 13.6609 3.49789 13.1344C2.70985 12.6078 2.09565 11.8594 1.73295 10.9838C1.37026 10.1082 1.27536 9.14467 1.46026 8.21512C1.64516 7.28556 2.10156 6.43171 2.77173 5.76153C3.4419 5.09136 4.29576 4.63497 5.22531 4.45007C6.15487 4.26517 7.11838 4.36006 7.994 4.72276C8.86963 5.08545 9.61804 5.69966 10.1446 6.4877C10.6711 7.27574 10.9522 8.20222 10.9522 9.14999C10.9524 9.77956 10.8286 10.403 10.5876 10.9847C10.3467 11.5663 9.99347 12.0948 9.54811 12.5397C9.10275 12.9847 8.57401 13.3375 7.99216 13.578C7.41031 13.8184 6.78676 13.9418 6.15719 13.941L6.16018 13.942Z",
    fill: "#f95c5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerred);
export default __webpack_public_path__ + "static/media/timerred.369a4f4d7bd50ef7d1d7e7f322d48836.svg";
export { ForwardRef as ReactComponent };